//import "react-perfect-scrollbar/dist/css/styles.css"
//import "bootstrap/dist/css/bootstrap.min.css"
//import "react-big-calendar/lib/css/react-big-calendar.css"
//import 'react-tagsinput/react-tagsinput.css'
//import 'react-date-picker/dist/DatePicker.css'
//import "dropzone/dist/min/dropzone.min.css"
import "rc-switch/assets/index.css"
import {setupAuthInterceptor} from './helpers/authInterceptor'


let render = () => {
    import('./assets/css/styles.scss').then(x => {
        require('./AppRenderer')
    })
}
setupAuthInterceptor()
render()